import { BasicTable } from '@fullscreendigital/carrefour-dex-fe'
import { getColumns } from './helpers'
import s from '../../../../commonStyles.modules.scss'
import { useQuery } from 'react-query'
import { makeCoreGetRequest } from 'utils/api'
import { useNotification } from 'hooks'
import { formatErrorMessage } from 'utils/formatting'
import { CircularProgress, TableContainer } from "@mui/material";
import { toTableRowItems } from './serializers'
import { useLocation, useParams } from "react-router-dom";
import { InfoItems } from "../../../../../core-ui/InfoItems";

const Details = () => {
  const { showNotification } = useNotification()
  const location = useLocation()
  const { id } = useParams()

  const data = (location.state as { list?: any[] } | null)?.list
  const selected = data?.find(item => String(item.id) === String(id))

  const {
    data: details = [],
    isLoading: isDataLoading
  } = useQuery(
    ['return-truck-details', id],
    async () => {
      const res = await makeCoreGetRequest(
        `/shop-reception/ds-return-trucks/details/${id}`
      )
      return toTableRowItems(res.list)
    },
    {
      enabled: !!id,
      onError: (error) => {
        showNotification({
          message: `A apărut o eroare la obținerea sigiliilor. ${formatErrorMessage(error)}`,
          type: 'error'
        })
      }
    }
  )

  return isDataLoading ? (
    <CircularProgress color="primary" style={{ margin: '40px auto' }} disableShrink />
  ) : (
    <div className={s.mainContainer}>
      <InfoItems
        itemsPerRow={3}
        items={[
          { name: selected?.shopCode, label: 'Magazin(e):' },
          { name: selected?.supplierName, label: 'Nume Furnizor:' },
          { name: selected?.truckNumber, label: 'Numar inmatriculare:' },
          { name: selected?.driverName, label: 'Nume sofer:' },
          { name: selected?.registrationDate, label: 'Data inregistrare:' },
          { name: selected?.expeditionDate, label: 'Data expeditie:' },
        ]}
      />
      <TableContainer style={{ marginTop: 15, maxHeight: 600 }}>
        <BasicTable
          columns={getColumns()}
          rows={details}
          containerProps={{ className: s.table }}
        />
      </TableContainer>
    </div>
  )
}

export default Details
